module.exports = __webpack_public_path__ + "static/media/branch-detail-1800.9ac91ec0.jpg";